// extracted by mini-css-extract-plugin
export default {"test":"SliderItem_test__HeMbu","container":"SliderItem_container__L+ZvL","art_image":"SliderItem_art_image__Fqprg","description":"SliderItem_description__wYYTm"};